import { ALLOCATIONS_FILTER, ICrisisStore } from './types';

const initStore: ICrisisStore = {
  current: null,
  crisisCalls: [],
  crisisCallTeamMembers: [],
  allocationsFilter: ALLOCATIONS_FILTER.CRISIS_ONLY,
};

export default initStore;
